import { formatDateToYYYYMMDDHHmmKorean } from "@/common/util/date-util";
import { OrderDetailDto } from "@/types/dto/order-detail-dto";
import { Breadcrumb } from "flowbite-react";
import { Body14Regular } from "../typography/Body14Regular";
import { H4 } from "../typography/H4";

interface Props {
  orderDetail: OrderDetailDto;
}

export const AdminOrderDetailHeader: React.FC<Props> = ({ orderDetail }) => {
  return (
    <div className="flex flex-col">
      <Breadcrumb className="pb-0">
        <Breadcrumb.Item>발주 관리</Breadcrumb.Item>
        <Breadcrumb.Item>발주 관리</Breadcrumb.Item>
        <Breadcrumb.Item>발주 상세</Breadcrumb.Item>
      </Breadcrumb>
      <div className="flex items-center justify-between h-[50px] mb-[12px]">
        <div className="mt-[15px] mb-[7px] flex gap-[12px]">
          <H4>발주 상세</H4>
          <div className="flex py-[3px] gap-[12px]">
            <Body14Regular className="text-semantic-text-secondary">
              발주일자: {formatDateToYYYYMMDDHHmmKorean(orderDetail.createdAt)}
            </Body14Regular>
            <Body14Regular className="text-semantic-text-secondary">
              발주번호: {orderDetail.invoiceNumber}
            </Body14Regular>
          </div>
        </div>
        <div />
        {/* <Button
          disabled={disabled}
          color={disabled ? ButtonColor.DISABLED : ButtonColor.PRIMARY}
          onClick={onClickButton}
        >
          정보 저장
        </Button> */}
      </div>
    </div>
  );
};
